import list from 'modules/company/list/companyListReducers';
import form from 'modules/company/form/companyFormReducers';
import view from 'modules/company/view/companyViewReducers';
import destroy from 'modules/company/destroy/companyDestroyReducers';
import importerReducer from 'modules/company/importer/companyImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
